export type IdentityMeResponse = {
  type: 'haven_guest';
  sub: string;
  isOwner: boolean;
  profile: {
    hid: string;
    title?: string;
    firstname?: string;
    lastname?: string;
    email?: string;
    address?: {
      postcode?: string;
    };
  };
};

export type IdentityMeResult =
  | { status: 'authenticated'; isOwner: boolean; data: IdentityMeResponse }
  | { status: 'guest' }
  | { status: 'error'; error: Error };

export const fetchIdentityMe = async (
  identityApiUrl: string,
  options: { refresh?: boolean; clientId?: string } = {}
): Promise<IdentityMeResult> => {
  const { refresh = false, clientId = 'owners' } = options;

  try {
    const response = await fetch(`${identityApiUrl}/identity/me`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ refresh, client_id: clientId }),
    });

    if (response.status === 204) {
      return { status: 'guest' };
    }

    if (response.status === 401) {
      return { status: 'guest' };
    }

    if (!response.ok) {
      throw new Error(
        `Identity API returned ${response.status}: ${response.statusText}`
      );
    }

    const data = (await response.json()) as IdentityMeResponse;

    return {
      status: 'authenticated',
      isOwner: data.isOwner,
      data,
    };
  } catch (error) {
    return {
      status: 'error',
      error: error instanceof Error ? error : new Error(String(error)),
    };
  }
};
